export default __webpack_public_path__ + "d55303d9a0673e954b76ac39e7149f12.png";